import { ThemeProvider, createTheme } from "@mui/material/styles";

import { useTemplateContext } from "./TemplateProvider";

const ThemeManagerProvider = ({ children }) => {
  const { template } = useTemplateContext();
  const muiTheme = createTheme(template?.theme ?? {});

  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default ThemeManagerProvider;
